// extracted by mini-css-extract-plugin
export var searchHeader = "_34-0";
export var searchHeaderDark = "_34-1";